import { OPEN_SIDENAV, CLOSE_SIDENAV, CURRENT_TAB } from "../../constants/actionTypes";

const initialState = {
    sidenavOpen: false,
    currentTab: "dashboard",
    darkMode: false,
    rtl: true
};

const exams = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_SIDENAV:
            return { ...state, sidenavOpen: true };
        case CLOSE_SIDENAV:
            return { ...state, sidenavOpen: false };
        case CURRENT_TAB:
            return { ...state, currentTab: action.payload };
        default:
            return state;
    }
};

export default exams;
